var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-bar-resizable-block",class:{ 'top-bar-resizable-block--moved': _vm.isMoved },style:(_vm.offsetValue)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }